import { CheckListLabel } from '../../filters/PersonalAndGeneralView/components/CheckListLabel';
import { OrganisationAreaSectionTitleProps } from '../types';

export const OrganisationAreaSectionTitle = ({
  children,
  rightElement,
}: OrganisationAreaSectionTitleProps) => {
  return <CheckListLabel value={children} rightElement={rightElement} />;
};
